import { useState } from "react";
import ModelUploader from "./MenuModelUpload";
import "@google/model-viewer";
import {
  FoodTypes,
  DietaryLabels,
  mapUserDimensionsToXYZ,
  standardSizes,
  getDimensionFieldsForFoodType,
} from "../../constants/itemOptions";

const MenuItemHeader = (props) => {
  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [description, setDescription] = useState("");
  const [foodType, setFoodType] = useState("OTHER");
  const [dietaryLabels, setDietaryLabels] = useState([]);
  const [autoScale, setAutoScale] = useState(true);
  const [modelFile, setModelFile] = useState(null);
  const [flatModelFile, setFlatModelFile] = useState(null);
  const [generateModel, setGenerateModel] = useState(false);
  const [customDimensions, setCustomDimensions] = useState({});

  const handleNameChange = (e) => setName(e.target.value);
  const handlePriceChange = (e) => setPrice(e.target.value);
  const handleDescriptionChange = (e) => setDescription(e.target.value);
  const handleModelUpload = (file) => setModelFile(file);
  const handleFlatModelUpload = (file) => setFlatModelFile(file);
  const handleScalingChange = (e) => setAutoScale(e.target.checked);
  const handleFoodTypeChange = (e) => setFoodType(e.target.value);
  const handleGenerateModelChange = (e) => setGenerateModel(e.target.checked);

  const handleSaveItem = () => {
    if (!flatModelFile) {
      alert("Please upload a 2d image file");
      return;
    } else if (!name || !price || !description) {
      alert("Please fill out all fields");
      return;
    }

    const {
      x: width,
      y: height,
      z: depth,
    } = mapUserDimensionsToXYZ(foodType, customDimensions);
    props.onNewItem({
      name,
      price,
      description,
      foodType,
      dietaryLabels,
      autoScale,
      generateModel,
      modelFile,
      flatModelFile,
      width,
      height,
      depth,
    });
    setName("");
    setPrice("");
    setDescription("");
    setFoodType("OTHER");
    setDietaryLabels([]);
    setAutoScale(true);
    setGenerateModel(false);
    setModelFile(null);
    setFlatModelFile(null);
    setCustomDimensions({});
  };

  const handleCancelItem = () => {
    console.log("test");
    setName("");
    setPrice("");
    setDescription("");
    setFoodType("OTHER");
    setDietaryLabels([]);
    setAutoScale(true);
    setGenerateModel(false);
    setModelFile(null);
    setFlatModelFile(null);
    setCustomDimensions({});
  };

  return (
    <div className="menu-item-header">
      <h2 className="menu-item-header-text">+ new item</h2>
      <div className="menu-item-header-content-container">
        <div className="menu-item-header-inputs">
          <div className="menu-item-price-name">
            <input
              type="text"
              className="menu-item-input name-input"
              placeholder="name"
              value={name}
              onChange={handleNameChange}
            />
            <input
              type="number"
              className="menu-item-input price-input"
              placeholder="price"
              value={price}
              onChange={handlePriceChange}
            />
          </div>
          <textarea
            type="text"
            className="menu-item-input description-input"
            placeholder="description"
            value={description}
            onChange={handleDescriptionChange}
          />
          <div className="menu-dietary-labels-container">
            {DietaryLabels.map((label) => {
              const formattedLabel = label.replace(/_/g, " ");
              return (
                <label key={label} className="menu-item-checkbox">
                  <input
                    className="menu-checkbox"
                    type="checkbox"
                    value={label}
                    checked={dietaryLabels.includes(label)}
                    onChange={(e) => {
                      const selectedLabels = dietaryLabels.includes(label)
                        ? dietaryLabels.filter((l) => l !== label) // Remove if already selected
                        : [...dietaryLabels, label]; // Add new selection
                      setDietaryLabels(selectedLabels);
                    }}
                  />
                  {formattedLabel}
                </label>
              );
            })}
          </div>
        </div>
        <div className="model-upload-container">
          <ModelUploader
            onModelUpload={handleModelUpload}
            modelFile={modelFile}
            type={"3d"}
          />
          <ModelUploader
            onModelUpload={handleFlatModelUpload}
            modelFile={flatModelFile}
            type={"2d"}
          />
        </div>
      </div>
      <div className="menu-autoscale-container">
        <div className="auto-scale-container">
          <label className="menu-item-label">
            <input
              className="menu-checkbox"
              type="checkbox"
              checked={autoScale}
              onChange={handleScalingChange}
            />
            auto scale
          </label>
        </div>
        {autoScale && (
          <div className="menu-item-label">
            <label>food type: </label>
            <select
              className="menu-food-type-select"
              value={foodType}
              onChange={handleFoodTypeChange}
            >
              {FoodTypes.map((type) => {
                const formattedType = type.toLowerCase();
                return (
                  <option key={type} value={type}>
                    {formattedType}
                  </option>
                );
              })}
            </select>
          </div>
        )}
        {flatModelFile && (
          <div className="model-gen-container">
            <label className="menu-item-label">
              <input
                className="menu-checkbox"
                type="checkbox"
                checked={generateModel}
                onChange={handleGenerateModelChange}
              />
              auto generate model
            </label>
          </div>
        )}
      </div>
      {autoScale && (
        <div className="menu-item-dimensions-container">
          {getDimensionFieldsForFoodType(foodType).map((dimKey) => (
            <input
              key={dimKey}
              type="number"
              className="menu-item-input"
              placeholder={`${dimKey} (cm)`}
              value={customDimensions[dimKey] || ""}
              onChange={(e) =>
                setCustomDimensions((prev) => ({
                  ...prev,
                  [dimKey]: e.target.value ? parseFloat(e.target.value) : "",
                }))
              }
            />
          ))}
        </div>
      )}
      <div className="menu-item-upload-action-buttons">
        <button className="menu-item-upload-cancel-button">
          <span
            className="menu-item-upload-button-text"
            onClick={() => handleCancelItem()}
          >
            cancel
          </span>
        </button>
        <button
          className="menu-item-upload-save-button"
          onClick={handleSaveItem}
        >
          <span className="menu-item-upload-button-text">save item</span>
        </button>
      </div>
    </div>
  );
};

export default MenuItemHeader;
